import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';

/**
 * Componente ManualPaymentCardComponent
 * Muestra la opción para realizar un pago manual con PSE.
 * @component
 */
@Component({
  selector: 'app-manual-payment-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './manual-payment-card.component.html',
  styleUrl: './manual-payment-card.component.scss',
})
export class ManualPaymentCardComponent {
  /**
   * Indica si esta tarjeta está seleccionada como método de pago.
   */
  isSelected = input(false);

  /**
   * Indica si el botón está deshabilitado (como signal input).
   */
  disabled = input(false);

  /**
   * Evento emitido cuando se hace clic en el botón de pago con PSE (como signal output).
   */
  payWithPSE = output<void>();
}
